import React from 'react'
import { get, size } from 'lodash'
import Number from '../Number'

const ProductPrice = ({ item }) => {
  const sellingPrice = get(item, 'sellingPrice', 0)
  const listPrice = get(item, 'listPrice', 0)
  const unitMultiplier = get(item, 'unitMultiplier', 1)
  const priceTags = get(item, 'priceTags', [])
  return (
    <>
      {
        (size(priceTags) > 0) && (
          <div style={{ textAlign: 'right' }}>
            <span>
              <del style={{ color: '#666666' }}><Number value={listPrice} /></del>
            </span>
          </div>
        )
      }
      <div style={{ textAlign: 'right' }}>
        <span>
          <Number value={sellingPrice / unitMultiplier} />
        </span>
      </div>
    </>
  )
}

export default ProductPrice
